import axios from 'axios';

export default function ({ agency = '', login = '', email = '' } = {}) {
  if (!agency) {
    return Promise.reject('Введите Ваше агентство');
  }
  if (!login) {
    return Promise.reject('Введите логин');
  }
  if (!email) {
    return Promise.reject('Введите адрес электронной почты');
  }
  return axios
    .post('/tourclient/account/restorePass', {
      partnerId: agency,
      login,
      email,
    })
    .then((data = {}) => {
      if (!data.IsSuccess) {
        return Promise.reject('В данный момент сервис недоступен');
      }
      return { message: 'Инструкция по восстановлению пароля выслана на Ваш адрес электронной почты' };
    });
}
